export const DESKTOP = 'desktop';
export const TABLET = 'tablet';
export const MOBILE = 'mobile';
import { DesktopIcon } from 'foundations-assets/icons/components/DesktopIcon';
import { MobileIcon } from 'foundations-assets/icons/components/MobileIcon';
import { TabletIcon } from 'foundations-assets/icons/components/TabletIcon';
export const PREVIEW_WIDTHS = {
  [DESKTOP]: 'inherit',
  [TABLET]: '826px',
  [MOBILE]: '520px'
};
export const BREAKPOINT_ICONS = {
  [DESKTOP]: DesktopIcon,
  [TABLET]: TabletIcon,
  [MOBILE]: MobileIcon
};
export const CUSTOM_BREAKPOINT_ICON = 'cssFile';